import type { SignupMinorNavigationState } from '@/types/signup';

export function isSignupMinorState(
  value: unknown,
): value is SignupMinorNavigationState {
  if (!value || typeof value !== 'object') {
    return false;
  }
  const record = value as Record<string, unknown>;
  return (
    typeof record.fullName === 'string' &&
    typeof record.email === 'string' &&
    typeof record.birthDate === 'string' &&
    typeof record.nationality === 'string' &&
    typeof record.document === 'string'
  );
}
